export const LanguageType = {
    ARABIC: 'ARABIC',
    BENGALI: 'BENGALI',
    CANTONESE: 'CANTONESE',
    ENGLISH: 'ENGLISH',
    FRENCH: 'FRENCH',
    GERMAN: 'GERMAN',
    GUJARATI: 'GUJARATI',
    ITALIAN: 'ITALIAN',
    LITHUANIAN: 'LITHUANIAN',
    MANDARIN: 'MANDARIN',
    OTHER_CHINESE: 'OTHER_CHINESE',
    POLISH: 'POLISH',
    PORTUGUESE: 'PORTUGUESE',
    PUNJABI: 'PUNJABI',
    SOMALI: 'SOMALI',
    SPANISH: 'SPANISH',
    TAMIL: 'TAMIL',
    TURKISH: 'TURKISH',
    URDU: 'URDU',
    WELSH: 'WELSH',
};

export type TLanguageType = typeof LanguageType[keyof typeof LanguageType];
